import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Environment } from 'services/Environment';

const isSubdomainURL = (url: Location | undefined): boolean => {
    if (!url) {
        return false;
    }
    const hostname = url.hostname;
    const hostnamesToIgnore = [
        `localhost`,
        `${Environment.DOMAIN}`,
        `beta.${Environment.DOMAIN}`,
        `public-web.${Environment.DOMAIN}`,
        `public-web.beta.${Environment.DOMAIN}`,
    ];
    return (
        hostnamesToIgnore.includes(hostname) === false && hostname.includes('.vercel.app') === false
    );
};

export const useIsSubdomain = (): boolean => {
    const [isSubdomain, setIsSubdomain] = useState<boolean>(isSubdomainURL(window?.location));
    const location = useLocation();
    useEffect(() => {
        setIsSubdomain(isSubdomainURL(window?.location));
    }, [location]);
    return isSubdomain;
};
